import { Component, OnInit } from '@angular/core';
import { NavService, Menu } from '../../../../services/nav.service';
import { LogincacheService } from '../../../../../graphqlserver/logincache.service';
import {User} from '../../../../../modules/principal/models/usermodel';
import{Router}from '@angular/router';

import { UsuarioService } from "../../../../../modules/complemento/services/usuario.service";
import { ConfiguracionService } from "../../../../../modules/complemento/services/configuracion.service";
import { Usuario } from "../../../../../modules/complemento/models/usuarios";
import { Configmodel } from "../../../../../modules/complemento/models/configuracion";
import {SnotifyService,SnotifyPosition,SnotifyStyle} from 'ng-snotify';
import CryptoES from 'crypto-es';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {global} from '../../../../../graphqlserver/conection';

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss']
})
export class MegaMenuComponent implements OnInit {

  public megaItems: Menu[];
  public levelmenuitems: Menu[];
  public habilitar:boolean=false;

  public claveactual:string='';
  public clavenueva1:string='';
  public clavenueva2:string='';
  public clave:string='';
  public roles:any;

  public perfil:User;
  public m_usuario:Usuario=new Usuario();
  public m_config:Configmodel=new Configmodel();

  public _admin:boolean=false;
  public _confuser:boolean=false;
  
  constructor(private modalService: NgbModal,private snotifyService: SnotifyService, private usuarioService: UsuarioService,public navServices: NavService,private usercache:LogincacheService,private router:Router,private configuracionService:ConfiguracionService) { 
  }

  ngOnInit() {
    this.habilitar=false;
    this._admin=false;
    this._confuser=false;
    this.perfil=this.usercache.getUserLoggedIn();
    if(Object.entries(this.perfil.permisos).length==0){
      this.habilitar=false;
    }else{
      this.roles=this.perfil.permisos;
      this.roles.forEach(element => {
      if(element.label=="Administrador"){
        this.habilitar=true;
        this._admin=true;
      }
      if(element.label=="Personal")
        this.habilitar=true;
      if(element.label=="Roles de Usuario"){
        this.habilitar=true;
        this._confuser=true;
      }
        
      });
    }
  }
  

  megaMenuToggle() {
    this.navServices.levelMenu = false;
    this.navServices.megaMenu  = !this.navServices.megaMenu;
    if(window.innerWidth < 991) { 
      this.navServices.collapseSidebar = true;
    }
  }

  levelMenuToggle() {
    this.navServices.megaMenu  = false;
    this.navServices.levelMenu = !this.navServices.levelMenu;
    if(window.innerWidth < 991) { 
      this.navServices.collapseSidebar = true;
    }
  }

  salir(){
    event.preventDefault();
    localStorage.removeItem('token');
    localStorage.removeItem('x-key');
    localStorage.removeItem('info');
    localStorage.removeItem('frrhh');
    this.router.navigateByUrl('/sigrrhh/principal/login');
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.megaItems.forEach(a => {
        if (this.megaItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }


  async listaUsuarios(ci:string){
    await this.usuarioService.listausuarios(ci).subscribe(
      res=>{
        this.m_usuario=res[0];
      },
      err=>{console.error(err);}
    );
  }

  async listaconfiguracion(){
    await this.configuracionService.listaconfiguracion().subscribe(
      res=>{
        if(res[0]){
          this.m_config=res[0];
        }else{
          this.m_config=new Configmodel();
        }
      },
      err=>{console.error(err);}
    );
  }

  async actualizaUsuario(dato:Usuario) {
    await this.usuarioService.changePassword(dato.idcarnet, dato.clave).subscribe(
      res => {
        if (res && res.success) {
          this.snotifyService.success('La contraseña fue cambiada', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            icon: 'assets/mingob/notify.png',
            position: SnotifyPosition.rightTop
          });
          localStorage.removeItem('token');
          localStorage.removeItem('x-key');
          localStorage.removeItem('frrhh');
          localStorage.removeItem('info');
          this.router.navigateByUrl('/sigrrhh/principal/login');
        } else {
          this.snotifyService.warning(res.message || 'No se pudo cambiar la contraseña', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            icon: 'assets/mingob/notify.png',
            position: SnotifyPosition.rightTop
          });
        }
      },
      err => {
        console.error(err);
        const errorMsg = err.error?.message || err.error?.error || 'Ocurrio un error al cambiar la contraseña';
        this.snotifyService.error(errorMsg, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          icon: 'assets/mingob/notify.png',
          position: SnotifyPosition.rightTop
        });
      }
    );
  }


  async actualizaConfiguracion(dato:Configmodel) {
    await this.configuracionService.actualizaconfig(dato).subscribe(
      res=>{
        var msg:any=res.data;
        this.snotifyService.success(msg.actualizaConfig[0].res.mensaje, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          icon: 'assets/mingob/notify.png',
          position:SnotifyPosition.rightTop
        });
      },
      err=>{console.error(err);
      }
    );
  }

  MensajeMutation(datom:any){
    if(datom){
      if(datom[0].res.valor==1){
        this.snotifyService.success('La contraseña fue cambiada', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          icon: 'assets/mingob/notify.png',
          position:SnotifyPosition.rightTop
        });
        localStorage.removeItem('token');
        localStorage.removeItem('x-key');
        localStorage.removeItem('frrhh');
        localStorage.removeItem('info');
        this.router.navigateByUrl('/sigrrhh/principal/login');
      }else{
        this.snotifyService.warning(datom[0].res.mensaje, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          icon: 'assets/mingob/notify.png',
          position:SnotifyPosition.rightTop
        });
      }
    }else{
      this.snotifyService.error('Ocurrio un error en la transacción de datos', {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        icon: 'assets/mingob/notify.png',
        position:SnotifyPosition.rightTop
      });
    }
  }

  open(content) {
    this.claveactual='';
    this.clavenueva1='';
    this.clavenueva2='';
    this.clave='';
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        var bytes = CryptoES.AES.decrypt(this.m_usuario.clave, global.secret);  
		    this.clave = bytes.toString(CryptoES.enc.Utf8);
        if(this.clave==this.claveactual){
          if(this.clavenueva1==this.clavenueva2){
            this.m_usuario.clave=this.clavenueva1;
            this.actualizaUsuario(this.m_usuario);
          }else{
            this.snotifyService.error('ERROR, Las contraseñas nuevas no coinciden', {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              icon: 'assets/mingob/notify.png',
              position:SnotifyPosition.rightTop
            });
          }
        }else{
          this.snotifyService.error('ERROR. La contraseña actual, no es correcta', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            icon: 'assets/mingob/notify.png',
            position:SnotifyPosition.rightTop
          });
        }
    }, () => {});
  }


  open2(content2) {
    this.listaconfiguracion();
      this.modalService.open(content2, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
       this.actualizaConfiguracion(this.m_config);
    }, () => {});
  }


}
